import styled from "@emotion/styled";
import { Button } from "react-aria-components";

export const StyledSwitchFloaty = styled(Button)`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing["2"]};
  padding-block: ${({ theme }) => theme.spacing["2"]};
  padding-inline: ${({ theme }) => theme.spacing["3"]};
  border-radius: ${({ theme }) => theme.borderRadius.xlarge};
  box-shadow: ${({ theme }) => theme.shadows.surface};
  background-color: ${({ theme }) => theme.colors.background.button.default.default};

  transition: 0.25s ease;

  &:active {
    transform: scale(0.99);
    background-color: ${({ theme }) => theme.colors.background.button.emphasisLight.default};
    color: ${({ theme }) => theme.colors.text.emphasis};
  }

  &[data-selected="true"] {
    background-color: ${({ theme }) => theme.colors.background.button.emphasisLight.default};
    color: ${({ theme }) => theme.colors.text.emphasis};

    &:hover {
      background-color: ${({ theme }) => theme.colors.background.button.emphasisLight.hover};
    }

    .mds-icon {
      color: ${({ theme }) => theme.colors.text.emphasis};
    }
  }

  &:disabled {
    cursor: none;
    pointer-events: none;
    background-color: ${({ theme }) => theme.colors.background.button.default.default};
  }
`;

export const LeftContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing["2"]};
`;

export const RightContainer = styled.div`
  display: flex;
  align-items: center;
`;
